import CheckIcon from '@material-ui/icons/Check';
import { useStyles } from './AddStageInfo2.styles';

interface AddStageInfoProps {
  backToPreviousStage?: () => void;
}

export default function AddStageInfo2(props: AddStageInfoProps) {
  const classes = useStyles();

  return (
    <>
      <div className={classes.numberCircleOutline} onClick={props.backToPreviousStage}>
        <div className={classes.numbersInCirclesOutline}>
          <CheckIcon></CheckIcon>
        </div>
      </div>
      <div className={classes.textOutline} onClick={props.backToPreviousStage}>
        Dane osobowe
      </div>
      <hr className={classes.line}></hr>
      <div className={classes.numberCircleInline}>
        <div className={classes.numbersInCirclesInline}>2</div>
      </div>
      <div className={classes.textInline}>Dane organizacyjne</div>
    </>
  );
}
